// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { all, call } from 'redux-saga/effects';

import { watchChat as chatSaga } from '../chat/saga/watchers';
import { watchWs as wsSaga } from '../ws/saga/watchers';
// IMPORTS

export function* rootSaga() {
  // eslint-disable-next-line prettier/prettier
  yield all([
    call(chatSaga),
    call(wsSaga),
  ]);
}

export default rootSaga;
